<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">广播列表</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="equipmentName">
            <el-input
              v-model="equipmentName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <treeselect
              v-model="areaCode"
              :options="regionDataTree"
              noResultsText="暂无选择项"
              placeholder="请选择区域"
            />
          </el-form-item>
          <el-form-item label="是否在线">
            <el-select v-model="IsOnline" placeholder="请选择">
              <el-option key label="全部" value=""></el-option>
              <el-option key label="在线" value="1"></el-option>
              <el-option key label="离线" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onSynch">同步广播设备</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="equipmentName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="equipmentNo" label="设备编号">
              </el-table-column>
              <el-table-column prop="equipmentIp" label="设备IP地址">
                <!-- <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).IP
                    }}
                  </span>
                </template> -->
              </el-table-column>
              <!--   :formatter="RegionNumToNameConverter" -->
              <el-table-column
                prop="areaCodeTranslated"
                label="区域"
              ></el-table-column>
              <el-table-column prop="longitude" label="经度"></el-table-column>
              <el-table-column prop="latitude" label="纬度"></el-table-column>
              <el-table-column prop="onlineStatusTranslated" label="状态">
                <!-- <template slot-scope="scope">
                  <span v-if="scope.row.IsOnline == false" style="color: red"
                    >离线</span
                  >
                  <span
                    v-else-if="scope.row.IsOnline == true"
                    style="color: green"
                    >在线</span
                  >
                </template> -->
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import utils from "../../../../../../utils";
import ZJApp from "../../../../../app";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { listEquipmentAreaTree, listEquipmentArea} from "@/api/src/equipmentArea";
import { listEquipment,delEquipment,tongEquipment} from "@/api/src/equipment";
const ZJPlayer = ZJApp.ZJPlayer;
const MediaCenter = ZJPlayer.MediaCenter;
const MSG = ZJPlayer.MediaCenterMsg;

export default {
  name: "DeviceManagerView",
  controller: "UI",
  action: "DeviceManagerView",
  components: {
    Treeselect
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      equipmentName: null,
      areaCode: null,
      regionDataTree: [],
      regionDataList: [],
      loading: false,
      loadingText: "",
      IsOnline: null, //在线是否
      endpoints: [],
    };
  },
  created: function () {
    this.getAreaTree();
    this.getAreaList();
  },
  mounted: function () {
    this.search();
    // this.logInfo.ActionName = "广播设备查询";
    // this.logInfo.LogMessage = "广播设备查询";
    // this.logInfo.ModuleName = "设备管理";
    // this.logInfo.PageName = "广播设备管理列表";
    // this.addOperationLog();
  },
  methods: {
    // 查询区域-树
    getAreaTree(){
      listEquipmentAreaTree().then(response => {
        // 修改tree字段
        const mapTree = obj => {
          const haveChildren = Array.isArray(obj.children) && obj.children.length > 0;
          return{
            id: obj.code,
            label: obj.label,
            children: haveChildren ? obj.children.map(i => mapTree(i)) : undefined
          }
        }
        this.regionDataTree = response.data.map(obj => mapTree(obj));
      });
    },
    // 查询区域-列表
    getAreaList(){
      listEquipmentArea().then(response => {
        this.regionDataList = response.rows;
      })
    },
    RegionNumToNameConverter(row) {
      let arr = this.regionDataList.filter(item => {
        return item.areaCode == row.RegionId
      });
      if(arr.length){
        return arr[0].areaName
      }
    },
    search() {
      this.loading = true;
      this.loadingText = "加载中...";
      let searchInfo = {
        equipmentName: this.equipmentName,
        areaCode:this.areaCode,
        categoryCode: "broadcast",
        onlineStatus: this.IsOnline,
        PageSize: this.pageSize,
        pageNum: this.currentPage
      };
      listEquipment(searchInfo).then(res=>{
        this.loading = false;
        if(res.code==200){
          this.tableData = res.rows;
          this.total = res.total;
        }else{
          this.tableData = [];
          this.total = 0;
        }
      })
      // new MyApis.TranResourcesApi()
      //   .GetEquipmentPagingList(searchInfo)
      //   .then((r) => {
      //     r = r.data.Data;
      //     this.tableData = r;
      //     this.tableData = r.PageContents;
      //     this.total = r.BaseSearch.TotalCount;
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      //   });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/broadcast/UI/DeviceManagerInfo",
        query: {
          areaTree: this.regionDataTree,
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/broadcast/ui/DeviceManagerInfo",
        query: { areaCode: row.areaCode, InfoId: row.id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/broadcast/ui/DeviceManagerInfo",
        query: { areaCode: row.areaCode, InfoId: row.id, type: "edit", areaTree: this.regionDataTree, },
      });
    },
    //行删除
    deleteClick(index, row) {
      console.log(row)
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delEquipment({id:row.id}).then(res=>{
            if(res.code==200){
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.search();
            }else{
              this.$message({
                  type: "error",
                  message: "删除失败!",
                });
            }
          })
          // new MyApis.TranResourcesApi()
          //   .DelEquipment(row)
          //   .then((r) => {
          //     r = r.data.Data;
          //     if (r) {
          //       this.$message({
          //         type: "success",
          //         message: "删除成功!",
          //       });
          //     } else {
          //       this.$message({
          //         type: "error",
          //         message: "删除失败!",
          //       });
          //     }
          //     this.logInfo.ActionName = "广播设备删除";
          //     this.logInfo.LogMessage = r
          //       ? "广播设备删除成功"
          //       : "广播设备删除失败";
          //     this.logInfo.ModuleName = "设备管理";
          //     this.logInfo.PageName = "广播设备管理列表";
          //     this.addOperationLog();
          //     this.search();
          //   })
          //   .catch((e) => {
          //     console.log(e);
          //   });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //同步广播设备
    onSynch() {
      this.loading = true;
      this.loadingText = "查询设备数据库...";
      let that = this;
      tongEquipment().then(res=>{
        console.log("同步设备",res)
        if(res.code==200){
          setTimeout(function(){
            that.search()
          },60000)
        }
      })
      // that.mc = new MediaCenter({
      //   address: this.CNF("mediaCenter.extend.broadcast"),
      // });
      // that.mc.on("connected", () => that.onConnected());
      // that.mc.on("msg", (e) => that.onRecv(e));
      // that.mc.on("error", (e) => that.onError(e));
      that.handleLoad();
    },
    SynchData() {
      let that = this;
      utils
        .waitAll([() => listEquipmentArea({pageNum:1, PageSize: 999}), () => this.getEquipments()])
        .then((r) => {
          let regionArr = r[0].rows;
          regionArr.forEach(item => {
            item.RegionId = item.areaCode;
            item.RegionName = item.areaName;
          })
          let regionMap = {};
          //根据regionid索引区域
          regionArr.forEach((element) => {
            regionMap[element.RegionId] = element;
          });
          //无相同名称的区域时，使用此区域作为新同步设备的区域
          let defRegion = regionArr
            .filter((item) => {
              return item.RegionName == "其他" || item.RegionName == "其它";
            })
            .slice(0, 1);
          if (defRegion.length == 0) {
            defRegion = regionArr.slice(0, 1);
          }

          let deviceArr = r[1].data.Data;
          let deviceMap = {};
          //根据deviceid索引设备
          deviceArr.forEach((element) => {
            deviceMap[element.DeviceId] = element;
          });

          console.log(that.endpoints);
          let dev = {
            JsonExtend: {
              DeviceNum: null,
              ShortName: null,
              IP: null,
              WarrantyPeriod: null,
              Remark: null,
              Address: null,
            },
          };
          let exists = {};
          let totalNum = 0;
          let added = 0;
          let updated = 0;
          let deleted = 0;
          that.endpoints.forEach((item) => {
            if (deviceMap[item.Id]) {
              dev = {
                JsonExtend: {
                  DeviceNum: null,
                  ShortName: null,
                  IP: null,
                  WarrantyPeriod: null,
                  Remark: null,
                  Address: null,
                },
                Longitude: deviceMap[item.Id].Longitude,
                Latitude: deviceMap[item.Id].Latitude,
              };
              that.Copy(dev, item);

              if (dev.RegionId == "" || dev.RegionId == undefined) {
                dev.RegionId = defRegion[0].RegionId;
                dev.RegionName = defRegion[0].RegionName;
              }
              dev.JsonExtend = JSON.stringify(dev.JsonExtend);
              dev.EquipmentType = "Broadcast";
              dev.Modifier = ZJApp.ZJUser.current.UserName;
              dev.ModifyTime = new Date();
              that.UpdateEquipment(dev);
              updated = updated + 1;
            } else {
              dev = {
                JsonExtend: {
                  DeviceNum: null,
                  ShortName: null,
                  IP: null,
                  WarrantyPeriod: null,
                  Remark: null,
                  Address: null,
                },
              };
              // dev.JsonExtend = JSON.parse(dev.JsonExtend);
              that.Copy(dev, item);
              if (dev.RegionId == "" || dev.RegionId == undefined) {
                dev.RegionId = defRegion[0].RegionId;
                dev.RegionName = defRegion[0].RegionName;
              }
              dev.JsonExtend = JSON.stringify(dev.JsonExtend);
              dev.EquipmentType = "Broadcast";
              dev.Modifier = ZJApp.ZJUser.current.UserName;
              dev.ModifyTime = new Date();
              dev.Creater = ZJApp.ZJUser.current.UserName;
              dev.CreateTime = new Date();
              dev.Validity = 1;
              that.AddEquipment(dev);
              added = added + 1;
            }
            exists[dev.DeviceId] = true;
            totalNum = totalNum + 1;
            //更新进度百分比
            let percent = (100 * totalNum) / that.endpoints.length;
            that.loadingText = `同步设备信息... ${percent}%"`;
          });
          if (totalNum > 0) {
            deviceArr.forEach((item) => {
              if (!exists[item.DeviceId]) {
                item.Modifier = ZJApp.ZJUser.current.UserName;
                item.ModifyTime = new Date();
                item.Validity = 0;
                that.DelEquipment(item);
                deleted = deleted + 1;
              }
            });
          }
          that.loading = false;
          if (added > 0 || updated > 0 || deleted > 0) {
            setTimeout(() => {
              that.search();
            }, 1000);
          }

          this.$message({
            type: "info",
            message: `"同步成功，新增 ${added} 个，更新 ${updated} 个，移除 ${deleted} 个，共 ${totalNum} 个设备。"`,
          });
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //获取设备列表
    getEquipments() {
      return new MyApis.TranResourcesApi().GetEquipmentMangeList({
        EquipmentType: "Broadcast",
      });
    },
    // 加载设备
    handleLoad() {
      this.endpoints = [];
      this.loading = true;
      this.loadingText = "加载广播设备中...";
      if (this.mc.$connected) {
        this.beginGetEndpoints();
      } else {
        this.mc.connect().then(() => this.beginGetEndpoints());
      }
    },

    // 成功连接到媒体中心
    onConnected() {
      //this.beginGetRegions();
    },

    beginGetEndpoints() {
      // 发送命令：获取终端设备数据
      this.mc.sendCmd(MSG.Get_End_Points);
    },

    onError(e) {
      console.error(e);
      let msg = e && e.error && e.error.message ? e.error.message : e;
      this.$message.error("出错了: " + msg);
      this.loading = false;
    },

    // 接收到媒体中心的响应
    onRecv(e) {
      console.log(e);
      const msg = e.data;
      if (msg.isResponse()) {
        console.log(msg);
        switch (msg.msgCode) {
          case MSG.Get_End_Points:
            this.onGetEndpoints(msg.getJsonData());
            break;
          case MSG.Start_TTS:
            var r = msg.getJsonData();
            if (r && r.code == "0" && r.data) {
              this.tempTaskId = r.data;
              this.$message.success("文字广播成功");
            } else {
              this.$message.error("文字广播失败");
            }
            break;
        }
      }
    },

    // 处理获取设备的响应
    onGetEndpoints(r) {
      if (r && r.code == "0" && r.data) {
        const list = r.data;
        console.log(list);
        for (let i = 0; i < list.length; i++) {
          this.endpoints.push(list[i]);
        }

        if (this.endpoints.length >= list.length) {
          this.loadingText = "加载广播设备...100%";
          this.SynchData();
        }
      } else {
        this.loading = false;
        console.error(r && r.msg ? r.msg : "未获取到设备信息");
        this.$message.error(r && r.msg ? r.msg : "出错了: 无设备信息");
      }
    },
    Copy(dest, src) {
      dest.DeviceId = src.Id;
      dest.DeviceName = src.Name;
      dest.IsOnline = src.Online != 0;
      // dest.JsonExtend = JSON.parse(dest.JsonExtend);
      dest.JsonExtend.IP = src.Address;
      dest.JsonExtend.MacAddr = src.MacAddr;
      dest.JsonExtend.Volume = src.Volume;
      dest.JsonExtend.Type = src.Type;
      dest.JsonExtend.Version = src.Version;
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.equipmentName = "";
      this.areaCode = "";
      this.IsOnline = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    UpdateEquipment(dev) {
      new MyApis.TranResourcesApi()
        .UpdateEquipment(dev)
        .then((r) => {
          r = r.data.Data;
          if (r) console.log("修改成功");
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    AddEquipment(dev) {
      new MyApis.TranResourcesApi()
        .AddEquipment(dev)
        .then((r) => {
          r = r.data.Data;
          if (r) console.log("添加成功");
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    DelEquipment(dev) {
      new MyApis.TranResourcesApi()
        .DelEquipment(dev)
        .then((r) => {
          r = r.data.Data;
          if (r) console.log("删除成功");
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item{
  vertical-align: middle;
}
::v-deep .vue-treeselect__control{
  width: 178px;
  height: 4rem;
  border-radius: 0px;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  /* line-height: unset; */
  /* line-height: 29px !important; */
}
::v-deep .vue-treeselect__menu{
  border-radius: 0px;
}
::v-deep .vue-treeselect__control{
  background:rgba(7, 78, 133, 0.7);
  border-color: rgba(7, 78, 133, 0.7);
  color: #fff !important;
}


/* 下拉菜单容器和选项列表背景 */
::v-deep .vue-treeselect__dropdown,
::v-deep .vue-treeselect__menu {
  background-color: rgba(7, 78, 133, 0.7) !important;
}
/* 如果启用了搜索框，同时修改搜索框的背景 */
::v-deep .vue-treeselect__dropdown .vue-treeselect__search {
  background-color: rgba(7, 78, 133, 0.7) !important;
}

::v-deep .vue-treeselect__option--highlight {
  background-color: rgba(7, 78, 133, 0.7) !important;
  color: #fff !important;
}
::v-deep .vue-treeselect__single-value {
    color: #fff !important;
}
</style>
